<template>
  <header class="nav">
    <div class="nav-inner container">
      <div class="brand">
        <img src="/logo-zg.jpg" alt="Zentral Games" />
        <strong></strong>
      </div>

      <!-- botón móvil -->
      <button class="menu-btn btn" @click="open = !open">
        {{ open ? 'Cerrar' : 'Menú' }}
      </button>

      <nav :class="['nav-links', { open }]">
        <router-link to="/" @click.native="open=false">Torneos</router-link>
        <router-link to="/leaderboard" @click.native="open=false">Leaderboard</router-link>

        <!-- Login / Perfil -->
        <template v-if="!isAuth">
          <router-link to="/login" @click.native="open=false">Login</router-link>
        </template>

        <template v-else>
          <div class="dropdown" v-outside="closeDrop">
            <!-- Split button -->
            <div class="split">
              <!-- parte izquierda: navega al dashboard -->
              <router-link class="btn secondary left"
                           to="/dashboard"
                           @click.native="open=false; openDrop=false">
                {{ (me && me.displayName) || (me && me.username) || 'Mi perfil' }}
              </router-link>
              <!-- parte derecha: caret que abre menú -->
              <button class="btn secondary right" @click="toggleDrop" aria-label="Abrir menú de perfil">▾</button>
            </div>

            <div class="dropdown-menu" v-if="openDrop">
              <router-link to="/dashboard" @click.native="openDrop=false; open=false">Ver perfil</router-link>
              <a href="#" @click.prevent="doLogout">Cerrar sesión</a>
            </div>
          </div>
        </template>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data: () => ({ open:false, openDrop:false }),
  computed: { ...mapGetters(['isAuth','me']) },
  methods:{
    ...mapActions(['logout']),
    toggleDrop(){ this.openDrop = !this.openDrop; },
    closeDrop(){ this.openDrop = false; },
    async doLogout(){
      await this.logout();
      this.closeDrop();
      this.open = false;
      this.$router.push('/');
    }
  },
  directives:{
    // v-outside: cierra al hacer click fuera
    outside:{
      bind(el, binding){
        el.__clickOutside__ = (e)=>{
          if (!(el === e.target || el.contains(e.target))) {
            binding.value(e);
          }
        };
        document.addEventListener('click', el.__clickOutside__);
      },
      unbind(el){
        document.removeEventListener('click', el.__clickOutside__);
      }
    }
  }
}
</script>

<style scoped>
.split{ display:inline-flex; }
.split .left{ border-top-right-radius:0; border-bottom-right-radius:0; }
.split .right{ border-top-left-radius:0; border-bottom-left-radius:0; padding:10px 10px; }
</style>
